export function categoryIndexValidate(category){
    var result = true;

    result = validateId(category.id);
    if(!result) return result;

    result = validateName(category.name);
    if(!result) return result;

    result = validateDescription(category.description);

    return result;
}

function validateId(id){    
    if(Number.isInteger(id)) return true;
    else return false;
}

function validateName(name) {
    if(typeof name == "string" && name != "") return true;
    else return false;
}

function validateDescription(description) {
    if(typeof description == "string") return true;
    else return false;
}